// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/css/layer.css
// module id = 186
// module chunks = 21 32 33 34 36 38 39 44 45 52 53 58 59 60 61 62 63 64 69 70 72 73 74 75 84 85 86 87 88 89 90 94 95 96 98 100 101 103 104 105 106 107 109 111 113 114 115 116 117 119 120 121 122 123 124 125 127 128 129 130 131 136 137 140 141 142 143 144 145 146 151 153 154 155 157 158 161 164 166 167 168 169 170 173 177 179